import { Component, type ReactNode } from 'react';

interface Props { title: string; children: ReactNode; }
interface State { error: Error | null; }

export class PanelErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="h-full flex flex-col items-center justify-center gap-2 text-xs text-gray-500">
          <span>{this.props.title}: data unavailable</span>
          <button className="text-kinetica-400 hover:underline" onClick={() => this.setState({ error: null })}>
            retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
